import { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";

// Fetches 5-minute intraday data for the 1D view. Only runs when `enabled`.
export default function useIntraday(symbol, enabled, refreshKey = 0) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!symbol || !enabled) return;
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${BASE_URL}/intraday/${symbol}`)
      .then((response) => {
        if (cancelled) return;
        const payload = response.data;
        if (!Array.isArray(payload) || payload.length === 0) {
          setData([]);
          setError(`No intraday data for "${symbol}".`);
        } else {
          setData(payload);
          setError(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error(err);
        setError("Couldn't load intraday data. Please retry.");
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [symbol, enabled, refreshKey]);

  return { data, loading, error };
}
